import { render, staticRenderFns } from "./FeedsCard.vue?vue&type=template&id=5c196f69&scoped=true"
import script from "./FeedsCard.vue?vue&type=script&lang=js"
export * from "./FeedsCard.vue?vue&type=script&lang=js"
import style0 from "./FeedsCard.vue?vue&type=style&index=0&id=5c196f69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c196f69",
  null
  
)

export default component.exports